module.exports = __webpack_public_path__ + "img/android_sdk.e3214091.png";